import React from "react";
import Carousel, { Item } from "../../common/Carousel";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { RelatedCategoriesResult } from "~/common/Store/models/Category";

import("./relatedCarouselStyles.scss");
interface Props {
  relatedCategories: RelatedCategoriesResult[];
}

const RelatedCarousel = ({ relatedCategories }: Props) => {
  return (
    <Carousel>
      {relatedCategories.map((category) => (
        <Item sliderRight key={category.id}>
          <>
            <div className="border-transparent group-hover:border-gray-200 border-solid border flex-shrink-0 p-1">
              <NoScriptLazyImage
                alt=""
                role="presentation"
                src={category.image?.small}
                className="category_image"
                data-testid={`category_image-${category.id}`}
                data-src={category.image?.small}
              />
            </div>
            <div className="mt-2 max-w-xs text-center h-9">
              <a
                className="link-pseudo font-semibold text-xs leading-none break-words"
                title={category.name}
                href={category.link}
                data-testid="categoryLink"
                data-label={category.id}
                data-action="click"
              >
                {category.name}
              </a>
            </div>
          </>
        </Item>
      ))}
    </Carousel>
  );
};

export default RelatedCarousel;
